import React, { useEffect, useRef, useState } from 'react'
import ReactDOM from 'react-dom'
import style from './RatePlatform.module.css'


import API from "../../ApiConfig";
import { SET_USER_RATING_COMMENT } from '../../Utils/constant';
import { useSelector } from 'react-redux';
import cogoToast from 'cogo-toast-react-17-fix';
import Loader from '../../components/Loader';
const RatePlatform = ({isOpen, blockOutsideClick=false,onClose, setFeedBack, getList}) => {

    const dropdownRef = useRef(null);
    const [selectedEmoji, setSelectedEmoji] = useState("")
    const [selectedEmojiName, setSelectedEmojiName]=useState("")
    const [comment,setComment]=useState("")
    const emojis = [
      { symbol: "😡", label: "Very Dissatisfied" },
      { symbol: "😞", label: "Dissatisfied" },
      { symbol: "😐", label: "Neutral" },
      { symbol: "😊", label: "Satisfied" },
      { symbol: "🤩", label: "Very Satisfied" },
    ]
    
    const [loading, setLoading]=useState(false)
    const User=useSelector(state=>state.User)
    const [feedBackError, setFeedBackError]=useState("")
    const handleClickOutside = (event) => {
        if (blockOutsideClick) return
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            onClose(false);
        }
    };
    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    useEffect(() => {
        return function () {
            document.removeEventListener('keydown', handleKeyPress)
            let body = document.getElementsByTagName("body")[0]
            body.classList.remove('modal-open')
        }
    }, [isOpen])

    function handleKeyPress(e) {
        if (e.keyCode == 27)
            onClose(false)
    }
    const handleSubmit=(e)=>{
      e.preventDefault()
      setLoading(true)
      if(comment!==""){
      let apiData={
        user_id:User.user_id,
        rating:selectedEmojiName,
        comment:comment
      }
      API.post(SET_USER_RATING_COMMENT, apiData)
      .then(res=>{
        if(res.status==200){
          setLoading(false)
          getList()
          // setFeedBack(false)  
          cogoToast.success("Thanks For Your Response!!")        
        }
        
      })
      .catch(err=>{
        // debugger
        setLoading(false)        
        setFeedBackError(err.response?.data?.message || "Something Went Wrong")
        
      })}
      else{
        setFeedBackError("Enter Comment")
      }
    }


    if (!isOpen)
        return null
    return ReactDOM.createPortal(
        <>
        
        <Loader isOpen={loading}/>
                            <body className={style.body}>
  <div className={style.modalOverlay} id="ratingModal">
    <div className={style.modal}>
    {/* <span className={style.closeBtn} onClick={onClose}>×</span> */}
      <h2>Rate the platform</h2>
      {feedBackError && (
        <div
          style={{
            backgroundColor: "#fee2e2",
            color: "#b91c1c",
            padding: "0.75rem 1rem",
            borderRadius: "8px",
            marginBottom: "1rem",
            fontWeight: "500",
            textAlign: "center",
          }}
        >
          {feedBackError}
        </div>
      )}
      <div className={style.stars} id="starContainer">


      {emojis.map((emoji) => (
    <div key={emoji.label} className={style.emojiContainer}>
      <span
        className={`${style.emoji} ${
          selectedEmoji === emoji.symbol ? style.selected : ""
        }`}
        onClick={() => {setSelectedEmoji(emoji.symbol), setSelectedEmojiName(emoji.label), setFeedBackError("")}}
      >
        {emoji.symbol}
      </span>
      <div className={style.tooltip}>{emoji.label}</div>
    </div>
  ))}
        
    </div>

    <textarea
    value={comment}
        placeholder="Write your feedback..."
        rows={4}
        style={{
          width: "300px",
          padding: "10px",
          borderRadius: "8px",
          border: "1px solid #ccc",
          maxLines:255,
          margin:"15px 0px"
        }}
        onChange={(e)=>{setComment(e.target.value)
          if(setFeedBackError){
            setFeedBackError("")
          }
        }}
      ></textarea>
      <button className="btn btn-primary" onClick={(e)=>handleSubmit(e)}>Submit</button>
    </div>
  </div>
  </body>

        </>
        , document.getElementById('modal-root')
    )
}

export default RatePlatform